import { useState } from "react";
//import { socialFB, socialIG } from "../../../../config/data";
//import SelectBasic from "../../../form/SelectBasic";
import CheckboxField from "../../../form/CheckboxField";
import { usePostHog } from "posthog-js/react";
import { Col, Row } from "antd";

export default function SocialFilter({ onChange }: any) {
  const [siteValue, setSiteValue] = useState<boolean>(false);
  const [linkedinValue, setLinkedinValue] = useState<boolean>(false);
  const [facebookValue, setFacebookValue] = useState<boolean>(false);
  const [instragramValue, setInstagramValue] = useState<boolean>(false);
  const [whatsappValue, setWhatsappValue] = useState<boolean>(false);
  const posthog = usePostHog();

  //const [social_fb, setSocial_fb] = useState<number | null>();
  //const [social_instagram, setSocial_instagram] = useState<number | null>();

  const handleChange = (field: string, value: any) => {
    onChange(field, value);
  };

  return (
    <Row>
      <span className="socialFIlterCheckboxWrapper">
        <CheckboxField
          name="site"
          value="Apenas empresa com Site"
          checked={siteValue}
          onChange={(e) => {
            posthog.capture('selecionar_site_checkbox');
            setSiteValue(e.target.checked);
            handleChange("site", e.target.checked);
          }}
        />
      </span>
      <span className="socialFIlterCheckboxWrapper">
        <CheckboxField
          name="linkedin"
          value="Apenas empresa com Linkedin"
          checked={linkedinValue}
          onChange={(e) => {
            posthog.capture('selecionar_linkedin_checkbox');
            setLinkedinValue(e.target.checked);
            handleChange("linkedin", e.target.checked);
          }}
        />
      </span>
      <span className="socialFIlterCheckboxWrapper">
        <CheckboxField
          name="facebook"
          value="Apenas empresa com Facebook"
          checked={facebookValue}
          onChange={(e) => {
            posthog.capture('selecionar_facebook_checkbox');
            setFacebookValue(e.target.checked);
            handleChange("facebook", e.target.checked);
          }}
        />
      </span>
      <span className="socialFIlterCheckboxWrapper">
        <CheckboxField
          name="instagram"
          value="Apenas empresa com Instagram"
          checked={instragramValue}
          onChange={(e) => {
            posthog.capture('selecionar_instagram_checkbox');
            setInstagramValue(e.target.checked);
            handleChange("instagram", e.target.checked);
          }}
        />
      </span>
      <span className="socialFIlterCheckboxWrapper">
        <CheckboxField
          name="whatsapp"
          value="Apenas empresa com Whatsapp"
          checked={whatsappValue}
          onChange={(e) => {
            posthog.capture('selecionar_whatsapp_checkbox');
            setWhatsappValue(e.target.checked);
            handleChange("whatsapp", e.target.checked);
          }}
        />
      </span>
      {/*                     Dropdowns de qtd de seguidores (removidos temporariamente)
      <SelectBasic
        mode="default"
        name="social_fb"
        label=""
        placeholder="Quantidade de users"
        options={socialFB}
        value={social_fb}
        onChange={(value) => {
          const unknownValue: unknown = value as unknown;
          const numberValue: number = unknownValue as number;
          setSocial_fb(numberValue);
          handleChange("social_fb", value);
        }}
      />
      
      <SelectBasic
        mode="default"
        name="social_instagram"
        label=""
        placeholder="Quantidade de users"
        options={socialIG}
        value={social_instagram}
        onChange={(value) => {
          const unknownValue: unknown = value as unknown;
          const numberValue: number = unknownValue as number;
          setSocial_instagram(numberValue);
          handleChange("social_instagram", value);
        }}
      />
      */}
    </Row>
  );
}
